import { createSlice } from '@reduxjs/toolkit';

const initialState: AppState = {
    isDeleteSimulationModalOpen: false
};

const appstateSlice = createSlice({
    name: 'appstate',
    initialState,
    reducers: {
        setDeleteSimulationModalOpen(state, action) {
            state.isDeleteSimulationModalOpen = action.payload;
        }
    }
});

export const { setDeleteSimulationModalOpen } = appstateSlice.actions;
export default appstateSlice.reducer;
